var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from 'react';
import { useLocalStorage, writeStorage } from '@rehooks/local-storage';
import { APPLIED_FILTERS_KEY } from '../../../../utils/constants';
import { getFilters } from '../../../../utils';
export var useFilters = function (filterConfig) {
    var storedAppliedFilters = useLocalStorage(APPLIED_FILTERS_KEY, filterConfig)[0];
    var _a = useState(storedAppliedFilters), appliedFilters = _a[0], setAppliedFilters = _a[1];
    var activeFilters = getFilters(appliedFilters);
    var filterCount = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length;
    var saveFilters = function (filters) {
        setAppliedFilters(filters);
        writeStorage(APPLIED_FILTERS_KEY, filters);
    };
    var onChangeFilter = function (e) {
        var target = e === null || e === void 0 ? void 0 : e.target;
        var filters = __assign({}, appliedFilters);
        if (target === null || target === void 0 ? void 0 : target.checked) {
            filters[target === null || target === void 0 ? void 0 : target.name] = true;
        }
        else {
            delete filters[target === null || target === void 0 ? void 0 : target.name];
        }
        saveFilters(filters);
    };
    var onResetAll = function () {
        saveFilters(filterConfig);
    };
    var onClearGroup = function (groupName) {
        var filters = __assign({}, appliedFilters);
        for (var name_1 in filters) {
            if (name_1.startsWith(groupName)) {
                delete filters[name_1];
            }
        }
        saveFilters(filters);
    };
    return { onChangeFilter: onChangeFilter, onClearGroup: onClearGroup, onResetAll: onResetAll, filterCount: filterCount, activeFilters: activeFilters, appliedFilters: appliedFilters };
};
